export type ApplicationQuestionnaireATMInfoItem = {
  ATMAddress?: string
  ATMAvgAmountReplenished?: number
  ATMFundsFromBank?: boolean
  ATMFundsFromBankFalseDesc?: string
  ATMMaxAmount?: number
  ATMReplenishFrequency?: string
}
